import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { IdentityProviderComponents } from "./components.ts";

const IdentityProviderFilters = {} as const satisfies AnyFilterSchema;
export type IdentityProviderFilters = typeof IdentityProviderFilters;

export const IdentityProviderRegistration = Registration({
  accesses: {},
  // Nothing is requestable here; the registry accepts only directory or resource.
  category: "resource",
  components: IdentityProviderComponents,
  docs: { install: "identity-provider" },
  filters: IdentityProviderFilters,
  itemKind: "provider",
  label: "Identity provider",
  logoUrl:
    "https://raw.githubusercontent.com/ant-design/ant-design-icons/refs/heads/master/packages/icons-svg/svg/outlined/safety-certificate.svg",
  maturity: "preview",
  requestType: "bridge",
  useMapping: [{ use: "identity", component: "provider" }],
});

registerIntegration("identity-provider", IdentityProviderRegistration);
